class BackInStockDrawer extends DrawerComponent {
  constructor() {
    super();
    this.currentVariantId = null;
    this.setupEventListeners();
  }

  connectedCallback() {
    super.connectedCallback();

    this.boundHandleGlobalClick = this.handleGlobalClick.bind(this);
    document.addEventListener('click', this.boundHandleGlobalClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.boundHandleGlobalClick) {
      document.removeEventListener('click', this.boundHandleGlobalClick);
    }
  }

  handleGlobalClick(event) {
    const target = event.target.closest('[aria-controls="BackInStockDrawer"]');
    if (target && target.dataset.variantId) {
      event.preventDefault();
      this.show(target);
    }
  }

  setupEventListeners() {
    const form = this.querySelector('.back-in-stock-drawer__form');
    const submitButton = this.querySelector('#notifyme__submit');

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitNotifyMe();
      });
    }

    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.submitNotifyMe();
      });
    }
  }

  get input() {
    return this.querySelector('input[type="email"]');
  }

  get focusElement() {
    return this.querySelector('input[type="email"]');
  }

  get variantIdInput() {
    return this.querySelector('input[name="variant_id"]');
  }

  get successMessage() {
    return this.querySelector('.form-message--success');
  }

  get errorMessage() {
    return this.querySelector('.form-error');
  }

  hideMessages() {
    if (this.successMessage) {
      this.successMessage.style.display = 'none';
    }
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  showSuccessMessage() {
    this.hideMessages();
    if (this.successMessage) {
      this.successMessage.style.display = 'block';
    }
  }

  showErrorMessage() {
    this.hideMessages();
    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';
    }
  }

  show(focusElement = null, animate = true) {
    this.hideMessages();

    if (focusElement && focusElement.dataset) {
      this.currentVariantId = focusElement.dataset.variantId;

      if (this.variantIdInput && this.currentVariantId) {
        this.variantIdInput.value = this.currentVariantId;
      }
    }

    super.show(focusElement, animate);
  }

  submitNotifyMe () {
    this.hideMessages();

    const klaviyoUrl = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoPublicKey}`;
    const payload = {
        "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": this.input.value,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${this.currentVariantId}`
            }
          }
        }
      }
    }

    var formObject = {
      method: 'POST',
      headers: {
        "content-type": "application/json",
        revision: "2024-10-15"
      },
      body: JSON.stringify(payload),
    }

    fetch(klaviyoUrl, formObject)
    .then((response) => {
      if(response.ok) {
        this.showSuccessMessage();
      } else {
        this.showErrorMessage();
      }
    }).catch(error => {
      console.log(error);
      this.showErrorMessage();
    });

  }
}
customElements.define('back-in-stock-drawer', BackInStockDrawer);
